import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import { catchError, filter, finalize, switchMap, take } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { TokenService } from "../services/token.service";


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  isRefreshingToken = false;

  constructor(private tokenService: TokenService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isInBlockedList(request.url)) {
      return next.handle(request);
    } else {
      return next.handle(this.addToken(request)).pipe(
        catchError(err => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 401:
                return this.handle401Error(request, next);
              case 404:
                return throwError(err);
              default:
                this.router.navigate(['error']);
            }
          } else {
            this.router.navigate(['error']);
            return throwError(err);
          }
        })
      );
    }
  }
  handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (!this.isRefreshingToken) {

      // Set to null so other requests will wait
      // until we got a new token!
      this.tokenSubject.next(null);
      this.isRefreshingToken = true;
      this.tokenService.currentAccessToken = null;

      // First, get a new access token
      return this.tokenService.getNewAccessToken().pipe(
        switchMap((token: any) => {
          if (token.isAuthenticated) {
            // Store the new token
            return this.tokenService.storeAccessToken(token).pipe(
              switchMap(_ => {
                // Use the subject so other calls can continue with the new token
                this.tokenSubject.next(token.token);
                this.tokenService.loadToken();
                // Perform the initial request again with the new token
                return next.handle(this.addToken(request));
              })
            );
          } else {
            // No new token or other problem occurred
            // redirect login page
            this.tokenService.deleteAccessToken();
            return this.router.navigateByUrl('/login', { replaceUrl: true });
          }
        }),
        finalize(() => {
          // Unblock the token reload logic when everything is done
          this.isRefreshingToken = false;
        })
      );
    } else {
      // "Queue" other calls while we load a new token
      return this.tokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(token => {
          // Perform the request again now that we got a new token!
          return next.handle(this.addToken(request));
        })
      );
    }
  }

  addToken(req: HttpRequest<any>) {
    if (this.tokenService.currentAccessToken) {
      return req.clone({
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.tokenService.currentAccessToken}`
        })
      });
    } else {
      return req;
    }
  }
  isInBlockedList(url: any) {
    if (url == `${environment.api_url}/Authenticate/login`) {
      return true;
    } else if (url == `${environment.api_url}/Authenticate/logout`) {
      return true;
    }
    else {
      return false;
    }
  }

}